import React, { useState } from 'react';
import { useAuth } from '../authentication/AuthContext';
import '../styles/HomePage.css';
import '../styles/ExpandedPersonas.css'
import '../index.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import '../i18n';
// import { useTranslation } from 'react-i18next';
import 'swiper/css/autoplay';
import { Navigation, Pagination, Autoplay } from 'swiper';
import { useFormSubmit } from '../services/useFormSubmit';
import { Link } from 'react-router-dom';


function AIInstantMarketInsights() {
  const { user } = useAuth();
  const [expandedFAQ, setExpandedFAQ] = useState([false, false, false, false]);
  const { submitStatus, handleSubmit } = useFormSubmit();
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleFAQ = (index) => {
    setExpandedFAQ(prev => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  const toggleCard = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  const personas = [
    {
      name: 'Emily',
      title: 'Marketing Manager',
      age: 34,
      salary: '€85,000/year',
      image: require('../components/personas/Emily.jpg'),
      backstory: "With 8 years of experience in digital marketing, Emily leads campaigns for major retail brands. She's passionate about data-driven decision making and building authentic brand voices.",
      interests: ['Digital Marketing', 'Yoga', 'Travel Photography'],
      challenges: 'Balancing creative innovation with ROI metrics',
      goals: ['Increase brand engagement by 25%', 'Develop sustainable marketing strategies']
    },
    {
      name: 'James',
      title: 'Retired School Principal',
      age: 67,
      salary: '€32,000/year (pension)',
      image: require('../components/personas/James.jpg'),
      backstory: 'James spent over 40 years in education, shaping the lives of thousands of students. Now retired, he volunteers at local literacy programs and enjoys spending time with his grandchildren.',
      interests: ['Gardening', 'Volunteering', 'Classical Music'],
      challenges: 'Staying active and engaged in the community',
      goals: ['Mentor young educators', 'Travel to historical sites']
    },
    {
      name: 'Sophie',
      title: 'Freelance Graphic Designer',
      age: 23,
      salary: '€28,000/year',
      image: require('../components/personas/Sophie.jpg'),
      backstory: 'Sophie is a recent art school graduate building her freelance portfolio. She works with startups and local businesses to create unique visual identities.',
      interests: ['Illustration', 'Street Art', 'Indie Music'],
      challenges: 'Finding steady clients and managing finances',
      goals: ['Land a major brand project', 'Host her first solo art show']
    },
    {
      name: 'Thomas',
      title: 'Factory Shift Supervisor',
      age: 51,
      salary: '€48,000/year',
      image: require('../components/personas/Thomas.jpg'),
      backstory: 'Thomas has worked in manufacturing for over 25 years, rising from line worker to supervisor. He values teamwork and safety on the job.',
      interests: ['Fishing', 'DIY Projects', 'Football'],
      challenges: 'Adapting to new automation technologies',
      goals: ['Improve team safety record', 'Save for early retirement']
    },
    {
      name: 'Sarah',
      title: 'University Student',
      age: 19,
      salary: '€6,000/year (part-time)',
      image: require('../components/personas/Sarah.jpg'),
      backstory: "Sarah is studying environmental science and works part-time at a café. She's passionate about sustainability and hopes to work for an NGO.",
      interests: ['Environmental Activism', 'Photography', 'Travel'],
      challenges: 'Balancing studies, work, and activism',
      goals: ['Win a research grant', 'Organize a campus sustainability event']
    },
    {
      name: 'Daniel',
      title: 'Paramedic',
      age: 41,
      salary: '€39,000/year',
      image: require('../components/personas/Daniel.jpg'),
      backstory: 'Daniel has been a paramedic for 15 years, responding to emergencies in both urban and rural areas. He also teaches first aid courses.',
      interests: ['Mountain Biking', 'Cooking', 'First Aid Training'],
      challenges: 'Managing stress and long shifts',
      goals: ['Train more community members in first aid', 'Complete a marathon']
    },
    {
      name: 'Laura',
      title: 'Entrepreneur (Bakery Owner)',
      age: 29,
      salary: '€54,000/year',
      image: require('../components/personas/Laura.jpg'),
      backstory: 'Laura opened her own bakery after years as a pastry chef. She\'s focused on organic, locally sourced ingredients and community engagement.',
      interests: ['Baking', 'Local Markets', 'Yoga'],
      challenges: 'Competing with large chains',
      goals: ['Open a second location', 'Develop a line of gluten-free products']
    },
    {
      name: 'Abdel',
      title: 'Taxi Driver',
      age: 58,
      salary: '€31,000/year',
      image: require('../components/personas/Abdel.jpg'),
      backstory: 'Abdel immigrated 20 years ago and has been driving a taxi ever since. He enjoys meeting new people and sharing stories from his home country.',
      interests: ['Chess', 'World News', 'Family Gatherings'],
      challenges: 'Navigating city changes and ride-share competition',
      goals: ['Buy a new car', 'Visit his hometown with his children']
    },
    {
      name: 'Ryan',
      title: 'University Student',
      age: 18,
      salary: '€1,200/year (odd jobs)',
      image: require('../components/personas/Ryan.jpg'),
      backstory: 'Ryan is a tech-savvy teenager who loves building robots and dreams of becoming an engineer. He does odd jobs for neighbors to save for college.',
      interests: ['Video Games', 'Skateboarding', 'Robotics Club'],
      challenges: 'Balancing schoolwork and hobbies',
      goals: ['Win a robotics competition', 'Get a scholarship for university']
    }
  ]

  return (
    <div className="home-page">
      <div className="top-hero hero hero-1">
        <div className="hero-grid-item">
          <h1>AI Instant Market Insights</h1>
          <h3>Validate your idea in minutes, not weeks</h3>
          <h3>The future of focus groups is here.</h3>
          <h3>Get instant user feedback through the power of AI.</h3>
          
          <div className="button-container">
            <Link to="/use-cases" className="button secondary-button">Explore use cases</Link>
            {user ? (
              <Link to="/research" className="standout-button button">Get Started</Link>
            ) : (
              <Link 
                to="/become-beta" 
                className="standout-button button"
              >
                Join our Beta &rarr;
              </Link>
            )}
          </div>
        </div>
       
      </div>

      <div className='hero hero-1'>
        <div className="problem-solution-grid">
          <div className="problem-solution-card solution-card">
            <h2>AI Instant Market Insights</h2>
            <h3>Fast, self-service market testing</h3>
            <p>Get instant feedback on your ideas without the wait of traditional research.</p>
            <ul className="highlight-list">
              <li>Tap into a ready-made pool of <strong>digital twins</strong> built from broad demographic and behavioral data.</li>
              <li>Get instant feedback on concepts, messages, or campaigns before you commit resources.</li>
              <li>Test and iterate in <span className="highlight">minutes, not months</span>.</li>
              <li>Ideal for startups, creative teams, and marketers who need speed and simplicity.</li>
            </ul>
          </div>
          
          <div className="problem-solution-card solution-card" style={{borderLeftColor:'var(--tertiary-color)', background: '#FFF'}}>
            <h2>Beta Access</h2>
            <h3>Help shape the future of market research</h3>
            <p>Join our Beta program and get early access to cutting-edge features.</p>
            <ul className="highlight-list">
              <li>Be among the <strong>first</strong> to use AI-powered market insights.</li>
              <li>Your feedback directly influences product development and new features.</li>
              <li>Limited seats available to ensure <span className="highlight">personalized support</span>.</li>
              <li>Access to exclusive Beta pricing and features as we grow.</li>
            </ul>
          </div>
        </div>
      </div>

      <div className='hero hero-1'>
        <h2>How does it work?</h2>
        <Link to="/exampleresearches" className="how-to-image-link">
          <img 
            src="/AI-insights.jpg" 
            alt="How to" 
            className="how-to-image desktop-image" 
          />
          <img 
            src="/how-to-picture-mobile.jpg" 
            alt="How to (mobile)" 
            className="how-to-image mobile-image" 
          />
        </Link>
      </div>

      <div className="hero hero-4" style={{backgroundColor: 'var(--secondary-color)'}}>
        <div className="faq-grid">
          <div className="faq-header">
            <h2>Some questions you may have:</h2>
          </div>
          <div className="faq-questions">
            <div className="faq-item">
              <h3 onClick={() => toggleFAQ(0)}>What is Quick Twin Testing (Beta)?</h3>
              <div className={`faq-answer ${expandedFAQ[0] ? 'expanded' : ''}`}>
                <p>Quick Twin Testing is a lighter version of InstantFlows designed for fast idea and message testing. It uses ready-to-go digital twins built on demographic data, so you can get quick insights without setting a full panel. The product is currently in beta as we continue adding new features and refining the experience.</p>
              </div>
            </div>
            <div className="faq-item">
              <h3 onClick={() => toggleFAQ(1)}>How do you create digital twins?</h3>
              <div className={`faq-answer ${expandedFAQ[1] ? 'expanded' : ''}`}>
                <p>Quick Twin Testing uses Ai-generated digital twins based on demographic and behavioral data. These twins simulate how real audiences think and respond, giving you realistic feedback without running new interviews.</p>
              </div>
            </div>
            <div className="faq-item">
              <h3 onClick={() => toggleFAQ(2)}>How is this different from traditional research?</h3>
              <div className={`faq-answer ${expandedFAQ[2] ? 'expanded' : ''}`}>
                <p>Traditional research requires new participants and data collection each time. Quick Twin Testing uses digital twins you can access instantly.</p>
              </div>
            </div>
            <div className="faq-item">
              <h3 onClick={() => toggleFAQ(3)}>What's the difference between the twins in the Personal Twin Panel product and the AI Instant Marketing Insights product?</h3>
              <div className={`faq-answer ${expandedFAQ[3] ? 'expanded' : ''}`}>
                <p>The AI Instant Marketing Insights product is a ready-to-use product that uses demographic twins based on statistical and demographic data and the user's selected demographic criteria, or a user's uploaded customer datasheet. This tool is currently in Beta and still developing to become the best version and most representative. Meanwhile, the personal twin panel is an in-depth process in which selected customers are interviewed and customer twins are made, based on each individual. This twin is then available to answer any questions you may have, at any time, in your personal InstantFlows library.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Personas section removed for AI Instant Market Insights page */}

      <div className="hero hero-1">
        <h2>Interested in InstantFlows?</h2>
        <div className="textbox">
          <p>Sign up to stay updated on our progress!</p>
          <form 
            id="interest-form" 
            action="https://script.google.com/macros/s/AKfycbz3X8mRhapnoT9XdfOdhJjXJhO2Q5X0Sz-0FbLsjCK81WlB0rOHiTP1ib3I6acjfC5dmg/exec" 
            method="POST" 
            className="interest-form"
            onSubmit={(e) => handleSubmit(e, 'interest-form')}
          >
            <input type="text" name="Name" placeholder="Your Name" required />
            <input type="email" name="Email" placeholder="Your Email" required />
            
            <button type="submit" className="button">Keep Me Updated</button>
            {submitStatus.message && (
              <div className={submitStatus.isError ? 'error-message' : 'success-message'}>
                {submitStatus.message}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default AIInstantMarketInsights;